import classnames from 'classnames';
import Image from 'next/image';
import React, { ForwardedRef } from 'react';

import line from '@/public/assets/images/global/career-opportunities/line.svg';

import styles from '@/components/global/buttons/button.module.scss';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  primary?: boolean;
  secondary?: boolean;
  phantom?: boolean;
  phantomDark?: boolean;
  brand?: boolean;
  classNames?: string;
  isDownload?: boolean;
  downloadType?: string;
  downloadSize?: string;
  t?: (key: string) => string;
}

const Button = (props: Props, ref?: ForwardedRef<HTMLButtonElement>): React.JSX.Element => {
  const {
    disabled,
    primary,
    secondary,
    phantom,
    phantomDark,
    brand,
    classNames,
    isDownload,
    downloadType,
    downloadSize,
    t,
    ...rest
  } = props;
  const className = classnames({
    [styles.button]: true,
    [styles.disabled]: disabled,
    [styles.primary]: primary,
    [styles.secondary]: secondary,
    [styles.phantom]: phantom,
    [styles.phantomDark]: phantomDark,
    [styles.brand]: brand,
    [styles.download]: isDownload
  });
  return (
    <button
      aria-disabled={disabled === true ? 'true' : undefined}
      className={`${className} ${classNames || ''}`}
      disabled={disabled}
      ref={ref}
      {...rest}
    >
      {props.children}
      {isDownload && t && (
        <div className={styles.type}>
          <div className={styles.media}>
            <span className={styles.text}>{props.downloadType || t('File')}</span>
            <Image alt={'underline'} className={styles.pdf} height={1} src={line} width={30} />
          </div>
          <div className={styles.media}>
            <span className={styles.text}>{t(',')}</span>
          </div>
          {props.downloadSize && (
            <div className={styles.media}>
              <span className={styles.text}>{props.downloadSize}</span>
              <Image alt={'underline'} className={styles.pdf} height={1} src={line} width={50} />
            </div>
          )}
        </div>
      )}
    </button>
  );
};

export default React.forwardRef(Button);
